import React from 'react';
import TaskClientInfoCard from '../TaskClientInfoCard.jsx';
import TaskDescriptionCard from '../TaskDescriptionCard.jsx';
import TaskDetailsCard from '../TaskDetailsCard.jsx';
import TaskLocationCard from '../TaskLocationCard.jsx';
import TaskQuickActionsCard from '../TaskQuickActionsCard.jsx';
import TaskStatusSection from '../TaskStatusSection.jsx';

const GeneralTab = ({
  loading,
  error,
  task,
  taskTypeLabel,
  priorityLabel,
  teamName,
  onViewTask,
  onRetry,
  onActionComplete
}) => {
  if (loading) {
    return (
      <div className="grid gap-6 xl:grid-cols-[minmax(0,1.9fr)_minmax(320px,0.95fr)]">
        <div className="space-y-6">
          <div className="animate-pulse rounded-3xl border border-line bg-surface/70 p-6">
            <div className="mb-4 h-5 w-40 rounded bg-surface-2" />
            <div className="h-3 w-11/12 rounded bg-surface-2" />
            <div className="mt-3 h-3 w-2/3 rounded bg-surface-2" />
          </div>

          <div className="animate-pulse rounded-3xl border border-line bg-surface/70 p-6">
            <div className="mb-4 h-5 w-44 rounded bg-surface-2" />
            <div className="h-3 w-full rounded bg-surface-2" />
            <div className="mt-3 h-3 w-full rounded bg-surface-2" />
            <div className="mt-3 h-3 w-4/5 rounded bg-surface-2" />
            <div className="mt-6 h-24 w-full rounded-2xl bg-surface-2/80" />
          </div>

          <div className="animate-pulse rounded-3xl border border-line bg-surface/70 p-6">
            <div className="mb-4 h-5 w-48 rounded bg-surface-2" />
            <div className="grid gap-3 sm:grid-cols-2">
              {[1, 2, 3, 4].map((item) => (
                <div key={item} className="rounded-xl border border-line p-3">
                  <div className="h-3 w-20 rounded bg-surface-2" />
                  <div className="mt-2 h-4 w-28 rounded bg-surface-2" />
                </div>
              ))}
            </div>
          </div>

          <div className="animate-pulse rounded-3xl border border-line bg-surface/70 p-6">
            <div className="mb-4 h-5 w-36 rounded bg-surface-2" />
            <div className="h-44 w-full rounded-2xl bg-surface-2/80" />
            <div className="mt-4 h-3 w-3/4 rounded bg-surface-2" />
          </div>
        </div>

        <div className="space-y-6">
          <div className="animate-pulse rounded-3xl border border-line bg-surface/70 p-6">
            <div className="mb-4 h-5 w-40 rounded bg-surface-2" />
            {[1, 2, 3].map((item) => (
              <div key={item} className="mb-3 last:mb-0">
                <div className="h-3 w-24 rounded bg-surface-2" />
                <div className="mt-2 h-4 w-10/12 rounded bg-surface-2" />
              </div>
            ))}
          </div>

          <div className="animate-pulse rounded-3xl border border-line bg-surface/70 p-6">
            <div className="mb-4 h-5 w-44 rounded bg-surface-2" />
            {[1, 2, 3].map((item) => (
              <div key={item} className="mt-3 h-12 w-full rounded-xl bg-surface-2/80" />
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-3xl border border-red-800/70 bg-red-950/20 p-8 text-center">
        <p className="text-lg font-semibold text-red-200">{error}</p>
        <button
          type="button"
          onClick={onRetry}
          className="mt-4 rounded-xl bg-red-600 px-4 py-2 text-sm font-medium text-content transition-colors hover:bg-red-500"
        >
          Reintentar
        </button>
      </div>
    );
  }

  if (!task) {
    return (
      <div className="rounded-3xl border border-line bg-surface/70 p-8 text-center text-content">
        No se encontró la tarea solicitada.
      </div>
    );
  }

  return (
    <div className="grid gap-6 xl:grid-cols-[minmax(0,1.9fr)_minmax(320px,0.95fr)]">
      <div className="space-y-6">
        <TaskStatusSection task={task} />
        <TaskDescriptionCard task={task} />
        <TaskDetailsCard
          task={task}
          taskTypeLabel={taskTypeLabel}
          priorityLabel={priorityLabel}
          teamName={teamName}
          onViewTask={onViewTask}
        />
        <TaskLocationCard client={task.client} />
      </div>

      <div className="space-y-6">
        <TaskClientInfoCard client={task.client} />
        <TaskQuickActionsCard
          task={task}
          onActionComplete={onActionComplete}
        />
      </div>
    </div>
  );
};

export default GeneralTab;